import styles from "../../../LoanRequestPage.module.scss";
import { AttachmentIcon } from "../../../../../../assets/icons";
import { OrderType } from "../../../../../../model/orders/orders";
import { CreditInfo } from "../../../../../../model/credit-info/credit-info";

type Props = {
	orderDetails: CreditInfo | undefined;
};

const AddressTab = ({ orderDetails }: Props) => {
	const isIndividual = !!orderDetails?.employeeData;
	const isBusiness = !!orderDetails?.businessOwnerData;
	
	// Computed values based on user type
	const userInfo = {
		fullName: isIndividual 
			? orderDetails?.employeeData?.fullName 
			: orderDetails?.businessOwnerData?.contactInformation?.name,
		phoneNumber: isIndividual 
			? orderDetails?.employeeData?.mobileNumber 
			: orderDetails?.businessOwnerData?.contactInformation?.phoneNumber,
		idCardName: isIndividual 
			? orderDetails?.employeeData?.identityData?.id 
			: orderDetails?.businessOwnerData?.companyName,
		documentUrl: isBusiness 
			? orderDetails?.businessOwnerData?.document?.urlToFile 
			: undefined,
		address: isIndividual 
			? orderDetails?.employeeData?.address 
			: orderDetails?.businessOwnerData?.companyAddress,
	};

	// const imgUrl = customer?.addressProofUrl ?? "";

	return (
		<section className={styles.detailsTabWrapper}>
			<div className={styles.detailsContent}>
				<div className={styles.item}>
					<div className={styles.label}>Address Submitted</div>
					<div className={styles.value}>
                           {userInfo.address}
					</div>
				</div>
				{/* <div className={styles.item}>
					<div className={styles.label}>Meter Number Address</div>
					<div className={styles.value}>{customer.meterNumber}</div>
				</div> */}
				{/* <div className={styles.item}>
					<div className={styles.label}>BVN Name</div>
					<div className={styles.value}>
						<div className={styles.value}>
							{!(customer?.bvnVerifyDetails?.firstName && customer?.bvnVerifyDetails?.lastName && customer?.bvnVerifyDetails?.middleName) ? (
								"/"
							) : (
								<>
									{customer?.bvnVerifyDetails?.firstName} {customer?.bvnVerifyDetails?.middleName} {customer?.bvnVerifyDetails?.lastName}
								</>
							)}
						</div>
					</div>
				</div> */}
				{/* <div className={styles.item}>
					<div className={styles.label}>Uploaded Proof of Address</div>
					<div className={styles.value}>
						<div className={styles.attachment} onClick={() => {
							window.open(imgUrl, "_blank");
						}}>
							<AttachmentIcon />
							View attachment
						</div>
					</div>
				</div> */}
				{/* <div className={styles.item}>
					<div className={styles.label}>Address Success Rate</div>
					<div className={styles.value}>{customer?.addressVerificationDetails?.confidenceLevel !== undefined ? `${customer.addressVerificationDetails?.confidenceLevel}%` : "Address was not valid"}</div>
				</div> */}
			</div>
		</section>
	);
};

export default AddressTab;
